<template>
  <div>
    <v-header></v-header>

    <div style="padding-top: 60px;">
      <div class="banner">
       
        <h2 class="item-title">
          <span class="eg">联系方式</span> 
          <!-- <mt-button type="danger">primary</mt-button> -->
          <span class="ch">
                                Please leave your honorable information, we will 
contact you as soon as possible
                            </span>
          <span class="chtwo">预留尊贵信息，我们将尽快与您联系</span>
        </h2>
      </div>
     
      <div class="formData">
        <form>
          
          <div >
            <span>姓名：</span>
            <input type="text" placeholder="" v-model="name" />
          </div>
          <div >
            <span>联系方式：</span>
            <input type="text" placeholder="" v-model="phone" />
          </div>
          <!-- <textarea rows="10" placeholder="所在省市：" v-model="note"></textarea> -->
          <div >
            <span>所在省市：</span>
            <input type="text" placeholder="" v-model="note" />
          </div>
          <div >
            <span>学校名称：</span>
            <input type="text" placeholder="" v-model="school" />
          </div>
          <input type="button" @click="submit" value="立即申请" />
          <p class="tips">提交成功后，我们的顾问24小时内会和您联系</p>
        </form>
      </div>
      
      <div class="dialog-box" v-show="success" >
        <div class="close" @click="success=false"></div>
        <div class="content">
          <img src="../../static/img/success.png">
          <p data-v-20c39d2d="">申请成功，我们的顾问会24小时内和您联系</p>
          <router-link to="/index"><input  type="button" value="返回首页" /></router-link>
        </div>
      </div>
      
      <div class="donut" v-show="donut" ></div>
      <div  class="tips-box" v-show="ts">
        <div  class="content">
          <p >{{msg}}</p>
        </div>
        <input  type="button" value="确定" @click="ts=false" />
      </div>
    </div>


    <div class="bg-mark" v-show="ts"></div>
    <div class="bg-mark" v-show="success"></div>
    <v-footer></v-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import header from './header.vue'
  import footer from './footer.vue'
  import { Toast } from 'mint-ui'; 
  export default {
    name: 'HelloWorld',
    data () {
      return {
        school:'',
        name:'',
        phone:'',
        wx:'',
        ts:false,
        msg:'',
        success:false,
        note:'',
        donut:false
      }
    },
    components :{
      'v-header':header,
      'v-footer':footer,
    },
    created() {
      localStorage.active = 10;
      let that=this
      //  this.$toast('请填写联系人姓名')
    // that.$messagebox({
    //                 title: '申请成功',
    //                 message: '感谢您的申请，我们会在24小时内和您联系!',
    //                 showCancelButton: false,
    //                 confirmButtonText: "返回首页",
    //                 // cancelButtonText: "取消"
    //             }).then(action => {
    //                 if (action == 'confirm') {
    //                     console.log('确定')
    //                     // window.location.href="./index"
    //                     that.$router.push({ path:'/'  })
    //                 } else {
    //                     console.log('取消')
    //                 }
    //           })
      
    },
    methods: {
      submit(){
        let re = /^1\d{10}$/;
       if(this.name == '' ){
          // this.ts = true;
          // this.msg = '请填写联系人姓名';
          this.$toast('请填写联系人姓名')
          return false;
        }
        if(this.phone == '' ){
          // this.ts = true;
          // this.msg = '请填写联系人手机号';
          this.$toast('请填写联系人手机号')
          return false;
        }
        if(!re.test(this.phone)){
          // this.ts = true;
          // this.msg = '手机号格式错误';
          this.$toast('手机号格式错误')
          return false;
        }
        if(this.school == '' ){
          // this.ts = true;
          // this.msg = '请填写学校名称';
          this.$toast('请填写学校名称')
          return false;
        }
       
        this.donut = true;

        let that = this;
        // 学校名称:1111；联系人姓名:18600；联系电话:18600754451；备注:123
        let info = '申请试用:学校名称:'+this.school+'；联系人姓名:'+this.name+'；联系电话:'+this.phone+'；备注:'+this.note;
        $.get(" http://www.100eks.com/contact.php?content="+info,function(data,status){
          // that.success = true;

            that.$messagebox({
                    title: '申请成功',
                    message: '感谢您的申请，我们会在24小时内和您联系!',
                    showCancelButton: false,
                    confirmButtonText: "返回首页",
                    // cancelButtonText: "取消"
                }).then(action => {
                    if (action == 'confirm') {
                        console.log('确定')
                        // window.location.href="./index"
                        that.$router.push({ path:'/'  })
                    } else {
                        console.log('取消')
                    }
              })
          that.donut = false;
        });




      }
    }

  }
</script>
<style >
  .mint-msgbox-confirm {
    font-size: 28px !important;
}

.mint-msgbox {
    border-radius: 20px !important;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .header {
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .main {
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    overflow-y: auto
  }

  .footer {
    width: 100%;
    -ms-flex-negative: 0;
    flex-shrink: 0
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }

  .moreline-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2
  }

  .clearfix:after {
    content: "";
    height: 0;
    width: 0;
    display: block;
    clear: both
  }

  .item-title {
    text-align: center;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-top: 20px;
  }

  .item-title .eg {
    margin: 50px auto;
    font-size:36px;
font-family:PingFang SC;
font-weight:bold;
color:rgba(42,177,243,1);
line-height:36px;
  }

  .item-title .ch {
    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
width:593px;
margin-bottom: 10px;
  }
.item-title .chtwo{
  font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:36px;
margin-top: 20px;
}
  .product-introduction {
    margin-top: 40px;
    padding: 0 5%;
    letter-spacing: 1px;
    line-height: 24px
  }

  .button {
    background: transparent;
    border: 1px solid rgba(42,177,243,1);
    color: rgba(42,177,243,1)

   
  }

  .banner {
    width: 100%;
    /* color: #fff; */
    /* position: relative */
  }

  .banner img {
    width: 100%
  }

  .banner input[type=button] {
    width: 100px;
    height: 40px;
    background: #2AB1F3;
    color: #fff;
    border-radius: 20px;
    font-size: 14px;
    margin-top: 20px
  }

  .banner .item-title {
    
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column
  }

  .formData {
    padding: 50px 0
  }

  .formData p {
    text-align: center;
    font-size: 18px
  }

  .formData form {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    /* margin-top: 10px */
  }

  .formData form div {
    /* border: 1px solid #999; */
    width: 93%;
    margin: 0 auto;
    height: 80px;
    margin-top: 35px;
    /* position: relative; */
    display: flex;
    flex-direction: row;
  }
  .formData form div span{
text-align: right;
font-size:30px;
font-family:PingFang SC;
font-weight:400;
color:rgba(0,0,0,1);
line-height:72px;
width:182px;
display: inline-block;
  }
.formData form div input{
/* flex: 1; */
margin-left: 20px;
width:450px;
height:80px;
background:rgba(255,255,255,1);
border:1px solid rgba(226,226,226,1);
text-indent: 0.3rem;
font-size:28px;
}
 

  .formData form input[type=button] {
   
    border: none;
    margin-top: 60px;

     width:630px;
height:88px;
background:rgba(42,177,243,1);
border-radius:10px;
font-size:36px;
font-family:PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);

  }


  .tips-box{
    width: 300px;
    max-height: 260px;
    border-radius: 10px;
    background: #fff;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -130px;
    margin-left: -150px;
    z-index: 101;
    overflow: hidden;
    padding: 20px 0;
  }

  .tips-box .content{
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-top: 10px;
    overflow-y: auto;
  }
  .tips-box input[type=button] {
    height: 36px;
    width: 80px;
    border-radius: 5px;
    color: #fff;
    border: none;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    background: #2AB1F3;
    margin-top: 30px;
    margin-left: 110px;
  }
  .bg-mark {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.2);
    z-index: 100;
  }

  .dialog-box {
    width: 80%;
    height: 360px;
    
    border-radius: 10px;
    /* background: #fff; */
    background: red;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -130px;
    margin-left: -150px;
    z-index: 101;
  }

  .dialog-box .close{
    height: 45px;
    width: 45px;
    position: absolute;
    top: 0;
    right: 0;
    background: url("~@/../static/img/close.png") no-repeat 50%;
    background-size: 15px 15px;
  }

  .dialog-box .content{
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 200px;
    margin-left: 50px;
  }

  .dialog-box .content img {
    width: 60px;
    height: 60px;
    margin-top: 40px;
  }

  .dialog-box .content p{
    text-align: center;
    letter-spacing: 1px;
    margin-top: 15px;
  }

  .dialog-box .content input[type=button]{
    height: 44px;
    width: 125px;
    border-radius: 5px;
    color: #fff;
    border: none;
    line-height: 44px;
    text-align: center;
    font-size: 16px;
    background: #2AB1F3;
    margin-top: 30px;
  }

  .donut{
    display: inline-block;
    border: 4px solid rgba(0,0,0,.1);
    border-left-color: #7983ff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: donut-spin-data-v-40c02c40 1.2s linear infinite;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -15px;
    margin-left: -15px;
    z-index: 101;
  }
  .formData form textarea {
    width: 250px;
    height: 80px;
    margin-top: 20px;
    padding: 10px;
    border: 1px solid #999;
    box-sizing: border-box;
  }

  .formData form .tips{
    margin-top: 35px;
    text-align: center;

    font-size:24px;
font-family:PingFang SC;
font-weight:400;
color:rgba(153,153,153,1);
line-height:21px;
  }
</style>



// WEBPACK FOOTER //
// src/components/applyfortrial.vue